import * as React from 'react';
import { TabPane, TabPaneProps } from 'reactstrap';

interface ILazyTabPaneProps extends TabPaneProps {
  tabId: TabPaneProps['tabId']
  activeTab: TabPaneProps['tabId']
}

export class LazyTabPane extends React.Component<ILazyTabPaneProps, {}> {
  render() {
    const { tabId, activeTab } = this.props
    const tabPaneProps = { ...this.props }

    delete tabPaneProps.activeTab

    return (
      <>
        {activeTab === tabId &&
          <TabPane {...tabPaneProps}>
            {this.props.children}
          </TabPane>
        }
      </>
    )
  }
}
